import React from 'react';
import './Home.css';
import bannerImg from '../assets/b-1.jpg';
import dirtBg from '../assets/dirt-bg.jpg';
import { FaTruck, FaPhoneAlt, FaExchangeAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // ✅ Import Link from React Router

function Home() {
  return (
    <div className="home">
      {/* Banner Section */}
      <div className="banner" style={{ backgroundImage: `url(${bannerImg})` }}>
        <div className="banner-content">
          <h1>Wholesale BC Native Plants</h1>
          <Link to="/quote" className="quote-button">Request a Plant Quote</Link> {/* ✅ Link to Quote */}
        </div>
      </div>

      {/* Best Selling Section */}
      <div className="best-selling-section">
        <h2>The Best Selling Plants</h2>
        <p>
          We strive every day to produce the best quality plants. Check out our bestselling plants below:
        </p>
        <Link to="/quote" className="quote-button">Request a Plant Quote</Link> {/* ✅ Link to Quote */}
      </div>

      {/* Grow with Peel Native Section */}
      <div className="grow-section" style={{ backgroundImage: `url(${dirtBg})` }}>
        <div className="grow-content">
          <h2>Grow with Peel Native Plants Ltd.!</h2>
          <p>
            Located in the heart of the Lower Mainland, Peel Native Plants Ltd. proudly specializes in the propagation and cultivation of top-quality BC native plants. Our plants are ideal for commercial and residential landscapes, habitat and wetland restoration, stream rehabilitation, mitigation projects, highways, parks, and more.
          </p>
          <p>
            With one of the largest inventories in the region and unmatched growing capabilities, we are ready to supply all your wholesale native plant needs — big or small!
          </p>
          <p>
            At Peel Native Plants, we’re passionate about delivering exceptional plants and outstanding customer service. Let’s grow success together!
          </p>
          <Link to="/about" className="quote-button">Learn More</Link> {/* ✅ Link to About */}
        </div>
      </div>

      {/* Mission Section */}
      <div className="mission-section">
        <div className="mission-content">
          <h2>Our Mission & Commitment</h2>
          <h4>We are committed to satisfy each customer. We are not stopping until you are fully satisfied.</h4>
          <p>
            Our mission is to produce good quality plants at reasonable price. And we are committed to take the Nursery line of business to next level where Landscapers, Developers, Retail customers, and Garden centers can purchase any plants through us via online, phone or e-mail without visiting our Nursery. Once order is placed our team works very dedicatedly to complete the order and deliver it.
          </p>

          <div className="mission-buttons">
            <Link to="/contact" className="quote-button contact-btn">Contact Now →</Link> {/* ✅ Link to Contact */}<br></br><br></br>
            <div className="availability-wrapper">
              <button className="availability-btn">Availability List</button> {/* This remains as a button (custom logic can be added) */}
            </div>
          </div>
        </div>
      </div>

      {/* Service Facilities Section */}
      <div className="service-section">
        <h2>Service Facilities</h2>
        <div className="service-boxes">
          <div className="service-box">
            <FaTruck className="service-icon" />
            <div className="service-text">
              <h3>Every Day, Every Order</h3>
              <p>Shipping starts from $50 and up<br />All orders over $100</p>
            </div>
          </div>
          <div className="service-box">
            <FaPhoneAlt className="service-icon" />
            <div className="service-text">
              <h3>Business Hours Support</h3>
              <p>604-217-1351</p>
            </div>
          </div>
          <div className="service-box">
            <FaExchangeAlt className="service-icon" />
            <div className="service-text">
              <h3>We Can Exchange</h3>
              <p>If the item didn’t suit you</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
